import {
  baggageRules,
  DEFAULT_BAGGAGE,
  HAND_BAGGAGE,
  HOLD_BAGGAGE,
} from './definitions';

import { allLegsHaveValidBaggageOption } from './simple';

const combinationHasValidBaggageInAnyLeg = (combination, predicate) => {
  const currentValid = predicate(combination.option);

  if (!currentValid) {
    return false;
  }

  if (!combination.next_leg_options?.length) {
    return true;
  }

  return combination.next_leg_options.some(next =>
    combinationHasValidBaggageInAnyLeg(next, predicate)
  );
};

export const getCustomClusterBaggage = (baggageOriginal, searchResults) => {
  const baggagesMap = new Map();
  baggagesMap.set(DEFAULT_BAGGAGE.value, DEFAULT_BAGGAGE);

  Object.entries(baggageRules).forEach(([key, predicate]) => {
    const isValid = searchResults.some(cluster =>
      cluster.combinations?.some(comb =>
        combinationHasValidBaggageInAnyLeg(comb, predicate)
      )
    );
    if (isValid) {
      baggagesMap.set(
        key,
        key === 'hand_baggage' ? HAND_BAGGAGE : HOLD_BAGGAGE
      );
    }
  });

  const extractedValues = new Set(Array.from(baggagesMap.keys()));
  return baggageOriginal.filter(b => extractedValues.has(b.value));
};

export const getClusterBaggage = (baggageOriginal, searchResults) => {
  const baggagesMap = new Map();
  baggagesMap.set(DEFAULT_BAGGAGE.value, DEFAULT_BAGGAGE);

  Object.entries(baggageRules).forEach(([key, predicate]) => {
    const isValid = searchResults.some(cluster =>
      allLegsHaveValidBaggageOption(cluster.legs, predicate)
    );

    if (isValid) {
      baggagesMap.set(
        key,
        key === 'hand_baggage' ? HAND_BAGGAGE : HOLD_BAGGAGE
      );
    }
  });

  const extractedValues = new Set(baggagesMap.keys());
  return baggageOriginal.filter(b => extractedValues.has(b.value));
};
